<!-- <ng-container *ngIf="field?.disable?.hideIfDisabled; else Display">
    <ng-container *ngIf="cFormControl.enabled" [ngTemplateOutlet]="Display"></ng-container>
</ng-container>

<ng-template #Display>
    <ng-content></ng-content>
</ng-template> -->
<ng-container *ngIf="!hide">
  <ng-container [ngTemplateOutlet]="Display"></ng-container>
  <ng-content select="[c-field-tooltip]"></ng-content>
</ng-container>

<ng-template #Display>
  <ng-content></ng-content>
</ng-template>
